import {
  FaLaptopCode, FaMobileScreenButton, FaPenRuler, FaSignature, FaPalette, FaPenNib, FaFilm, FaWandMagicSparkles,
  FaCameraRetro, FaCube, FaChalkboard, FaFileLines, FaBlog, FaPenToSquare, FaQuoteLeft, FaBookOpen, FaLanguage,
  FaSpellCheck, FaClosedCaptioning, FaMicrophoneLines, FaMusic, FaBullhorn, FaMagnifyingGlassChart, FaShareNodes,
  FaEnvelopeOpenText, FaHandshake, FaKeyboard, FaUserTie, FaHeadset, FaCalculator, FaFileInvoiceDollar,
  FaScaleBalanced, FaUsers, FaBriefcase, FaListCheck, FaChartLine, FaBrain, FaRobot, FaShieldHalved, FaNetworkWired,
  FaCloud, FaGamepad, FaBug, FaCartShopping, FaWordpress, FaCompassDrafting, FaCouch, FaChalkboardUser,
  FaPersonChalkboard, FaMagnifyingGlass, FaClipboardList, FaCalendarCheck, FaDumbbell, FaHandHoldingDollar,
  FaPodcast, FaShirt, FaBoxOpen, FaLinkedin, FaFileCode, FaDesktop, FaScrewdriverWrench,
} from "react-icons/fa6";

// The services sellers can offer on the Co-Work marketplace (Web Development, Graphic Designing, Resume
// Writing, Blog Posting, ...). Used by the Co-Work banner slides: the admin picks the expertise areas to
// feature and the slider shows them as pills. Stored comma-separated on the slide, keyed by a stable id.
export const SERVICE_ICONS = [
  // Development & IT
  { key: "svc-web-development", label: "Web Development", Icon: FaLaptopCode },
  { key: "svc-mobile-apps", label: "Mobile App Development", Icon: FaMobileScreenButton },
  { key: "svc-desktop-software", label: "Desktop Software", Icon: FaDesktop },
  { key: "svc-wordpress", label: "WordPress", Icon: FaWordpress },
  { key: "svc-ecommerce", label: "eCommerce Management", Icon: FaCartShopping },
  { key: "svc-game-dev", label: "Game Development", Icon: FaGamepad },
  { key: "svc-qa-testing", label: "Software Testing (QA)", Icon: FaBug },
  { key: "svc-website-maintenance", label: "Website Maintenance", Icon: FaScrewdriverWrench },
  { key: "svc-cloud-devops", label: "Cloud & DevOps", Icon: FaCloud },
  { key: "svc-it-support", label: "IT Support & Networking", Icon: FaNetworkWired },
  { key: "svc-cybersecurity", label: "Cybersecurity", Icon: FaShieldHalved },
  { key: "svc-ai-ml", label: "AI & Machine Learning", Icon: FaBrain },
  { key: "svc-chatbots", label: "Chatbot Development", Icon: FaRobot },
  { key: "svc-data-analysis", label: "Data Analysis", Icon: FaChartLine },
  // Design & Creative
  { key: "svc-graphic-design", label: "Graphic Designing", Icon: FaPenRuler },
  { key: "svc-logo-branding", label: "Logo & Branding", Icon: FaSignature },
  { key: "svc-ui-ux", label: "UI / UX Design", Icon: FaPalette },
  { key: "svc-illustration", label: "Illustration", Icon: FaPenNib },
  { key: "svc-3d-modeling", label: "3D Modeling", Icon: FaCube },
  { key: "svc-presentations", label: "Presentation Design", Icon: FaChalkboard },
  { key: "svc-print-packaging", label: "Print & Packaging Design", Icon: FaBoxOpen },
  { key: "svc-fashion-design", label: "Fashion & Apparel Design", Icon: FaShirt },
  { key: "svc-architecture-cad", label: "Architecture & CAD", Icon: FaCompassDrafting },
  { key: "svc-interior-design", label: "Interior Design", Icon: FaCouch },
  // Video, Audio & Photo
  { key: "svc-video-editing", label: "Video Editing", Icon: FaFilm },
  { key: "svc-animation", label: "Animation & Motion", Icon: FaWandMagicSparkles },
  { key: "svc-photography", label: "Photography", Icon: FaCameraRetro },
  { key: "svc-voice-over", label: "Voice Over", Icon: FaMicrophoneLines },
  { key: "svc-music-audio", label: "Music & Audio", Icon: FaMusic },
  { key: "svc-podcasting", label: "Podcasting", Icon: FaPodcast },
  // Writing & Translation
  { key: "svc-resume-writing", label: "Resume Writing", Icon: FaFileLines },
  { key: "svc-cover-letter-linkedin", label: "Cover Letter & LinkedIn", Icon: FaLinkedin },
  { key: "svc-blog-posting", label: "Blog Posting", Icon: FaBlog },
  { key: "svc-content-writing", label: "Content Writing", Icon: FaPenToSquare },
  { key: "svc-copywriting", label: "Copywriting", Icon: FaQuoteLeft },
  { key: "svc-technical-writing", label: "Technical Writing", Icon: FaFileCode },
  { key: "svc-ebook-writing", label: "Ebook Writing", Icon: FaBookOpen },
  { key: "svc-translation", label: "Translation", Icon: FaLanguage },
  { key: "svc-proofreading", label: "Proofreading & Editing", Icon: FaSpellCheck },
  { key: "svc-transcription", label: "Transcription", Icon: FaClosedCaptioning },
  // Marketing & Sales
  { key: "svc-digital-marketing", label: "Digital Marketing", Icon: FaBullhorn },
  { key: "svc-seo", label: "SEO", Icon: FaMagnifyingGlassChart },
  { key: "svc-social-media", label: "Social Media Management", Icon: FaShareNodes },
  { key: "svc-email-marketing", label: "Email Marketing", Icon: FaEnvelopeOpenText },
  { key: "svc-lead-generation", label: "Lead Generation & Sales", Icon: FaHandshake },
  { key: "svc-market-research", label: "Market Research & Surveys", Icon: FaClipboardList },
  // Admin & Support
  { key: "svc-data-entry", label: "Data Entry", Icon: FaKeyboard },
  { key: "svc-virtual-assistant", label: "Virtual Assistant", Icon: FaUserTie },
  { key: "svc-customer-support", label: "Customer Support", Icon: FaHeadset },
  { key: "svc-event-planning", label: "Event Planning", Icon: FaCalendarCheck },
  { key: "svc-research", label: "Research", Icon: FaMagnifyingGlass },
  // Business, Finance & Legal
  { key: "svc-accounting", label: "Accounting & Bookkeeping", Icon: FaCalculator },
  { key: "svc-tax-consulting", label: "Tax & Financial Consulting", Icon: FaFileInvoiceDollar },
  { key: "svc-financial-planning", label: "Financial Planning", Icon: FaHandHoldingDollar },
  { key: "svc-legal", label: "Legal Consulting", Icon: FaScaleBalanced },
  { key: "svc-hr-recruiting", label: "HR & Recruiting", Icon: FaUsers },
  { key: "svc-business-consulting", label: "Business Consulting", Icon: FaBriefcase },
  { key: "svc-project-management", label: "Project Management", Icon: FaListCheck },
  // Teaching & Coaching
  { key: "svc-tutoring", label: "Tutoring & Teaching", Icon: FaChalkboardUser },
  { key: "svc-coaching", label: "Online Coaching", Icon: FaPersonChalkboard },
  { key: "svc-fitness-coaching", label: "Fitness & Wellness Coaching", Icon: FaDumbbell },
];

export const SERVICE_ICON_MAP = Object.fromEntries(SERVICE_ICONS.map((i) => [i.key, i]));
